import { status } from '../../helpers'

const getLoginStoreDefaultState = () => {
  return {
    auth: {},
    loggingIn: false,
    signingUp: false,
    userEmail: '',
    isRequestingReset: false,
    isRequestingSuccess: false,
    sentResetMessage: '',
    changingPassword: status.INITIALIZED
  }
}

export default getLoginStoreDefaultState
